import React, { useCallback, useState } from 'react';
import { ExportOptions } from './export-options';
import CustomButton from '../../../../shared/custom-button/custom-button';
import CustomIcon from '../../../../shared/custom-icon/custom-icon';
import { SelectionOption } from '../../../../shared/selection-button/selection-option';

interface ExportAllFooterProps {
    onClose: () => void;
    onExport: (exportMethod: SelectionOption) => void;
    disabled: boolean;
}

export const ExportAllModalFooter: React.FC<ExportAllFooterProps> =({onClose, onExport, disabled}) => {
    const [selectedExportMethod, setSelectedExportMethod] = useState(ExportOptions[0]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleExport= () => {
        setIsLoading(true);
        onExport(selectedExportMethod);
    };
    
    const exportMethodOptionClass = useCallback((option: SelectionOption) => {
        return selectedExportMethod.key === option.key ? 'selected' : '';
    }, [selectedExportMethod]);

    return <div className="export-footer flex" >
        <div className="export-method-selection flex" data-testid="method-selection">
            {ExportOptions.map(option =>
                <CustomButton label={option.exportAllLabel} key={option.key} className={exportMethodOptionClass(option)}
                              onClick={() => setSelectedExportMethod(option)} prefixIcon={<CustomIcon type={option.icon} />}/>)}
        </div>
        <div className="export-modal-confirm-btns" data-testid="export-confirm-buttons">
            <CustomButton label={'Cancel'} key={'cancel'} className="secondary-btn" onClick={onClose}/>
            <CustomButton label={'Export'} key={'export'} className={`primary-btn ${isLoading?'loading':''}`} 
                          onClick={handleExport} isDisabled={disabled}/>
        </div>
    </div>;
};
